import i18n from "../../../i18n";

const DashboardBusinessControlsGridPluginSettings = (): IPluginSettings => {
    const t = (value: string) => i18n.t("sidePanel." + value);
    return {
        name: t("dashboardBusinessControls"),
        mnemocode: 'dashboard_business_controls_plugin',
        permission: 'Lot',
        columns: [{
            order: 1,
            propertyName: 'goodsName',
            propertyType: 'string',
            displayName: 'Товар',
            visibility: true,
            width: 400
        }, {
            order: 2,
            propertyName: 'quantityRem',
            propertyType: 'number',
            displayName: 'Кол-во (Остаток)',
            visibility: true,
            width: 200
        }, {
            order: 3,
            propertyName: 'retailPriceIncVat',
            propertyType: 'number',
            displayName: 'Цена розн. c НДС',
            visibility: true,
            width: 200
        }, {
            order: 4,
            propertyName: 'supplierPriceIncVat',
            propertyType: 'number',
            displayName: 'Цена поставщика с НДС',
            visibility: true,
            width: 200
        }, 
        
       
        ]
    }
}
export default DashboardBusinessControlsGridPluginSettings